import { getConfig } from '@townsquare/config';

import AvailableSitesProvider from './AvailableSites';

export const resolvedAvailableSitesProvider = new AvailableSitesProvider(getConfig().availableProductsUrl);
